var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import * as Icons from '../../atoms/icons';
import { css } from 'styled-components';
import { IconEdit } from '../../atoms/icons/16x16/Edit';
import BaseButton from './BaseButton';
import { theme } from '../../theme';
import { IconCaretDown } from '../../atoms/icons/16x16';
var getButtonPadding = function (props) {
    if (props.size === 'small')
        return '10px 24px';
    if (props.size === 'extraSmall')
        return '6px 16px';
    return '16px 32px';
};
var getButtonWidth = function (props) {
    if (props.stretch)
        return '100%';
    return 'auto';
};
export var SecondaryBaseStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  background: transparent;\n  padding: ", ";\n  border: 2px solid ", ";\n  position: relative;\n  box-sizing: border-box;\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:active {\n    background: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n"], ["\n  width: ", ";\n  background: transparent;\n  padding: ", ";\n  border: 2px solid ", ";\n  position: relative;\n  box-sizing: border-box;\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:active {\n    background: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n"])), function (props) { return getButtonWidth(props); }, function (props) { return getButtonPadding(props); }, theme.tints.aubergine, theme.tints.lightAubergine, theme.tints.darkAubergine, theme.tints.aubergine, theme.tints.darkAubergine, function (_a) {
    var style = _a.style;
    return style && style;
});
var SecondaryBase = styled(BaseButton).attrs(function () { return ({
    className: 'button button__secondary',
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    ", "\n    .icon__edit, .icon__caret-down, .icon__miles-input {\n      width: 16px;\n      height: 16px;\n    }\n    .icon {\n      display: flex;\n      align-items: center;\n      margin-right: 12px;\n    }\n    .icon__miles-input,\n    .icon__remove {\n      margin-right: ", "px;\n    }\n  }\n"], ["\n  && {\n    ", "\n    .icon__edit, .icon__caret-down, .icon__miles-input {\n      width: 16px;\n      height: 16px;\n    }\n    .icon {\n      display: flex;\n      align-items: center;\n      margin-right: 12px;\n    }\n    .icon__miles-input,\n    .icon__remove {\n      margin-right: ", "px;\n    }\n  }\n"])), SecondaryBaseStyles, theme.grid.spacing.xs);
export var ButtonSecondary = function (props) {
    var Icon = Icons[props.customIcon];
    return (_jsxs(SecondaryBase, __assign({}, props, { children: [props.customIcon && !props.icon && Icon && (_jsx(Icon, { fill: props.customFill || theme.primaryColours.aubergine.main })), props.icon && _jsx(IconEdit, {}), props.caretDown && _jsx(IconCaretDown, {}), props.label] })));
};
var templateObject_1, templateObject_2;
